import { PropertyService } from '@modules/property/property-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';

export default {
  namespaced: true,

  state: {
    loading: false,
  },

  getters: {
    loading: (state) => !!state.loading,
  },

  mutations: {
    DESTROY_ALL_STARTED(state) {
      state.loading = true;
    },

    DESTROY_ALL_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ALL_ERROR(state) {
      state.loading = false;
    },

    DESTROY_STARTED(state) {
      state.loading = true;
    },

    DESTROY_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ERROR(state) {
      state.loading = false;
    },
  },

  actions: {
    async doDestroy({ commit, dispatch, rootGetters }, id) {
      try {
        commit('DESTROY_STARTED');

        await PropertyService.destroyAll([id]);

        commit('DESTROY_SUCCESS');

        Message.success(i18n('entities.property.destroy.success'));

        routerAsync().push({ name: 'propertyList' });

        dispatch(
          `${'property/list'}/doFetch`,
          rootGetters[`${'property/list'}/filter`],
          {
            root: true,
          },
        );
      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ERROR');
      }
    },

    async doDestroyAll(
      { commit, dispatch, rootGetters },
      ids,
    ) {
      try {
        commit('DESTROY_ALL_STARTED');

        await PropertyService.destroyAll(ids);

        commit('DESTROY_ALL_SUCCESS');

        dispatch(`${'property/list'}/doUnselectAll`, null, {
          root: true,
        });

        Message.success(
          i18n('entities.property.destroyAll.success'),
        );

        dispatch(
          `${'property/list'}/doFetch`,
          rootGetters[`${'property/list'}/filter`],
          {
            root: true,
          },
        );
      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ALL_ERROR');
      }
    },
  },
};
